import React, { useEffect, useState } from "react";
import FooterNew from "../components/Footer-New";
import NavbarNew from "../components/Navbar-New.js";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// import api
import { contactUsApi } from "../api/users.js";
import { toastAlert } from "../lib/toastAlert.js";

export default function Contact(props) {
  const { t } = useTranslation();
  const siteDoc = useSelector((state) => state.siteSetting)

  console.log("...siteDoc",siteDoc);
  
  const [formValue, setFormValue] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Consultation form state
  const [consultationForm, setConsultationForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [consultationErrors, setConsultationErrors] = useState({});
  const [consultationLoader, setConsultationLoader] = useState(false);
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  const { name: cName, email: cEmail, phone: cPhone, message: cMessage } = consultationForm;

  const handleConsultationChange = (e) => {
    const { name, value } = e.target;
    setConsultationForm({ ...consultationForm, [name]: value });
    if (consultationErrors[name]) {
      setConsultationErrors({ ...consultationErrors, [name]: "" });
    }
  };

  const handleConsultationSubmit = async () => {
    setConsultationLoader(true);
    const { status, message, errors } = await contactUsApi(consultationForm);
    if (status === "success") {
      setConsultationLoader(false);
      setShowConsultationModal(true);
      setConsultationForm({ name: "", email: "", phone: "", message: "" });
    } else {
      setConsultationLoader(false);
      setConsultationErrors(errors || {});
      if (message) toastAlert("error", t(message), "consultation");
    }
  };

  const { name, email, phone, message } = formValue;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = async () => {
    setLoader(true);
    const { status, message, errors: apiErrors } = await contactUsApi(formValue);
    if (status === "success") {
      setLoader(false);
      setShowModal(true);
      setFormValue({ name: "", email: "", phone: "", message: "" });
    } else {
      setLoader(false);
      setErrors(apiErrors || {});
      if (message) toastAlert("error", t(message), "contact");
    }
  };

  return (
    <div>
      <NavbarNew />
      <div className="innerpages_wrapper">
        <div className="container">
          <div className="dash_wrapper">
            <section className="w-full relative">
              <div className="w-full max-w-[1720px] mx-auto flex flex-col lg:flex-row justify-between items-start gap-4 lg:gap-8">
                {/* Left Content */}
                <div className="w-full xl:w-2/4 flex flex-col justify-start items-start gap-6 relative z-10">
                  <div className="w-full flex flex-col justify-start items-start gap-3">
                    <div className="w-full justify-center text-[#395645] text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-normal font-['Forum']">
                      Contact Us
                    </div>
                  </div>
                  <div className="w-full justify-center text-[#3a4f66] text-sm sm:text-base md:text-lg font-normal font-['Roobert'] leading-relaxed md:leading-[28.80px]">
                    Tell us about your investment objectives, and a member of
                    our team will be in touch to discuss how MG Asset Management
                    may support your long term financial strategy.
                  </div>
                  <div className="flex flex-col justify-start items-start gap-2.5">
                    <div className="justify-center">
                      <span className="text-[#395645] text-sm md:text-base font-medium font-['Roobert']">
                        Email Address:{" "}
                      </span>
                      <span className="text-[#395645] text-sm md:text-base font-semibold font-['Roobert']">
                        <a
                          href="mailto:support@mgassetmanagement.com"
                          className="text-decoration-none text-dark"
                        >
                          {siteDoc?.supportMail || "support@mgassetmanagement.com"}
                        </a>
                      </span>
                    </div>
                    <div className="justify-center">
                      <span className="text-[#395645] text-sm md:text-base font-medium font-['Roobert']">
                        Phone Number:{" "}
                      </span>
                      <span className="text-[#395645] text-sm md:text-base font-semibold font-['Roobert']">
                        <a
                          href="tel:+447508 585044"
                          className="text-decoration-none text-dark"
                        >
                          {siteDoc?.contactNo || "+447508 585044"}
                        </a>
                      </span>
                    </div>
                    {/* <div className="justify-center">
                      <span className="text-[#395645] text-sm md:text-base font-medium font-['Roobert']">
                        Address:{" "}
                      </span>
                      <span className="text-[#395645] text-sm md:text-base font-semibold font-['Roobert']">
                        3 Abbey Road, London NW8 9DD
                      </span>
                    </div> */}
                  </div>
                  <div>
                    <div className="w-full justify-center text-[#395645] text-xl xl:text-3xl font-semibold font-['Forum']">
                      Why Contact MG Asset Management?
                    </div>
                    <ul className="mt-4 list-disc list-inside text-[#3a4f66] text-sm md:text-lg font-normal font-['Roobert'] leading-relaxed md:leading-[28.80px]">
                      <li>Family Run Integrity</li>
                      <li>Independent Perspective</li>
                      <li>Broad Investment Capability</li>
                      <li>Long Term Focus</li>
                    </ul>
                  </div>
                </div>

                {/* Right Form */}
                <div className="w-full xl:w-2/4 p-6 md:p-8 lg:p-12 bg-white rounded-[4px] flex flex-col justify-start items-start gap-6 md:gap-8 shadow-sm">
                  {/* Full Name */}
                  <div className="w-full flex flex-col justify-start items-start gap-2">
                    <label className="w-full text-[#3a4f66] text-sm md:text-lg font-normal font-['Roobert']">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      onChange={handleChange}
                      placeholder="Enter Full Name"
                      className="w-full px-3 md:px-4 py-3 md:py-[18px] bg-[#f4f3f3] rounded-[4px] text-gray-500 text-sm md:text-base font-normal font-['Roobert'] placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#395645]"
                    />
                    {errors.name && <span className="text-danger text-xs">{t(errors.name)}</span>}
                  </div>

                  {/* Email and Phone */}
                  <div className="w-full flex flex-col sm:flex-row justify-start items-start gap-6">
                    <div className="w-full sm:flex-1 flex flex-col justify-start items-start gap-2">
                      <label className="w-full text-[#3a4f66] text-sm md:text-lg font-normal font-['Roobert']">
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleChange}
                        placeholder="Enter Email Address"
                        className="w-full px-3 md:px-4 py-3 md:py-[18px] bg-[#f4f3f3] rounded-[4px] text-gray-500 text-sm md:text-base font-normal font-['Roobert'] placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#395645]"
                      />
                      {errors.email && <span className="text-danger text-xs">{t(errors.email)}</span>}
                    </div>
                    <div className="w-full sm:flex-1 flex flex-col justify-start items-start gap-2">
                      <label className="w-full text-[#3a4f66] text-sm md:text-lg font-normal font-['Roobert']">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={phone}
                        onChange={handleChange}
                        placeholder="Enter Phone Number"
                        className="w-full px-3 md:px-4 py-3 md:py-[18px] bg-[#f4f3f3] rounded-[4px] text-gray-500 text-sm md:text-base font-normal font-['Roobert'] placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#395645]"
                      />
                      {errors.phone && <span className="text-danger text-xs">{t(errors.phone)}</span>}
                    </div>
                  </div>

                  {/* Message */}
                  <div className="w-full flex flex-col justify-start items-start gap-2">
                    <label className="w-full text-[#3a4f66] text-sm md:text-lg font-normal font-['Roobert']">
                      Message
                    </label>
                    <textarea
                      name="message"
                      value={message}
                      onChange={handleChange}
                      placeholder="Enter Message"
                      rows={5}
                      className="w-full px-3 md:px-4 py-3 md:py-[18px] bg-[#f4f3f3] rounded-[4px] text-gray-500 text-sm md:text-base font-normal font-['Roobert'] placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-[#395645] resize-none"
                    />
                    {errors.message && <span className="text-danger text-xs">{t(errors.message)}</span>}
                  </div>

                  {/* Submit Button */}
                  <button 
                    className="primary_btn" 
                    onClick={handleSubmit}
                    disabled={loader}
                  >
                    {loader ? t("SENDING") : t("SEND_ENQUIRY")}
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>

        {/* Private Consultation Section */}
       
      </div>
      <FooterNew />

      {/* Success Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("CONTACT_US")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-5">
          <i className="bi bi-check-circle-fill text-success" style={{ fontSize: "4rem" }}></i>
          <h3 className="mt-4 font-['Forum'] text-[#395645]">{t("THANK_YOU")}</h3>
          <p className="text-[#3a4f66] mt-2">
            {t("CONTACT_SUCCESS_MSG", "Your enquiry has been sent successfully. Our team will get back to you shortly.")}
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-center border-0 pb-4">
          <Button 
            className="px-5 py-2 rounded-[4px] bg-[#395645] border-0" 
            onClick={() => setShowModal(false)}
          >
            {t("CLOSE")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Consultation Success Modal */}
      <Modal show={showConsultationModal} onHide={() => setShowConsultationModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("PRIVATE_CONSULTATION")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-5">
          <i className="bi bi-check-circle-fill text-success" style={{ fontSize: "4rem" }}></i>
          <h3 className="mt-4 font-['Forum'] text-[#395645]">{t("THANK_YOU")}</h3>
          <p className="text-[#3a4f66] mt-2">
            {t("CONSULTATION_SUCCESS_MSG", "Your request for a private consultation has been sent successfully. Our team will get back to you shortly.")}
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-center border-0 pb-4">
          <Button 
            className="px-5 py-2 rounded-[4px] bg-[#395645] border-0" 
            onClick={() => setShowConsultationModal(false)}
          >
            {t("CLOSE")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

